var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSend = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.617 8.871-.007-.003-16.682-6.92a.92.92 0 0 0-.868.085.963.963 0 0 0-.435.804v4.426a.937.937 0 0 0 .762.92l9.1 1.683a.157.157 0 0 1 0 .307l-9.1 1.682a.937.937 0 0 0-.762.92v4.426a.921.921 0 0 0 .414.77.936.936 0 0 0 .888.08l16.682-6.88.008-.003a1.25 1.25 0 0 0 0-2.297Z",
  fill: "currentColor"
})));
export { SvgSend as ReactComponent };